<template>
  <div class="right-valve">
    <div class="header-row">
      <div class="title-section">
        <img src="@/assets/gisWork/SVG/title-bg.svg" class="title-bg" />
        <span class="title-text">阀门统计</span>
      </div>
      <div class="total-value">
        <span class="number">{{ totalNum }}</span>
        <span class="unit">个</span>
      </div>
    </div>

    <!-- 百分比进度条列表 -->
    <div class="progress-list">
      <div class="progress-item" v-for="(item, index) in progressData" :key="index">
        <div class="progress-content" @mouseenter="showTooltip($event, item)" @mouseleave="hideTooltip">
          <span class="label">{{ item.label }}</span>
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: (item.percentage * 2 + 10) + '%' }"></div>
          </div>
          <span class="percentage">{{ item.percentage }}%</span>
        </div>
      </div>
    </div>

    <!-- 自定义悬浮提示 -->
    <div ref="tooltip" class="custom-tooltip" v-show="tooltip.visible">
      <div class="tooltip-content">
        <div class="tooltip-title">{{ tooltip.data.label }}</div>
        <div class="tooltip-item">数量(个): {{ tooltip.data.number }}</div>
        <div class="tooltip-item">占比: {{ tooltip.data.percentage }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightValve',
  data () {
    return {
      valveUrl: '/pipe-network/gis/pipe-networks/workbench/gate-valve',
      totalNum: 0,
      progressData: [],
      tooltip: {
        visible: false,
        data: {}
      }
    }
  },
  mounted () {
    this.fetchValveData()
  },
  methods: {
    async fetchValveData () {
      try {
        const response = await this.$http.get(this.valveUrl)
        const apiData = response.data

        // 更新总数
        this.animateNumber(apiData.gateValveNum)

        // 处理数据并计算百分比
        this.processValveData(apiData.gateValveTypeVos)

      } catch (error) {
        console.error('获取阀门数据失败:', error)
      }
    },
    animateNumber (targetValue) {
      const startValue = 0
      const duration = 2000
      const startTime = Date.now()

      const animate = () => {
        const elapsed = Date.now() - startTime
        const progress = Math.min(elapsed / duration, 1)

        const easeOutQuart = 1 - Math.pow(1 - progress, 4)
        const currentValue = startValue + (targetValue - startValue) * easeOutQuart

        this.totalNum = Math.round(currentValue)

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          this.totalNum = targetValue
        }
      }

      animate()
    },
    processValveData (valveData) {
      const total = valveData.reduce((sum, item) => sum + item.number, 0)

      this.progressData = valveData.map(item => ({
        percentage: ((item.number / total) * 100).toFixed(1),
        label: item.pipeDiameter,
        number: item.number
      })).filter(item => item.percentage > 0)
        .sort((a, b) => b.percentage - a.percentage)
    },
    showTooltip (event, item) {
      this.tooltip.data = item
      this.tooltip.visible = true
      this.$nextTick(() => {
        this.positionTooltip(event)
      })
    },
    hideTooltip () {
      this.tooltip.visible = false
    },
    positionTooltip (event) {
      const tooltip = this.$refs.tooltip
      if (tooltip) {
        const rect = event.target.getBoundingClientRect()
        const tooltipRect = tooltip.getBoundingClientRect()

        // 计算位置，避免超出视窗
        let left = rect.left + rect.width / 2 - tooltipRect.width / 2
        let top = rect.top - tooltipRect.height - 10

        // 边界检查
        if (left < 10) left = 10
        if (left + tooltipRect.width > window.innerWidth - 10) {
          left = window.innerWidth - tooltipRect.width - 10
        }
        if (top < 10) {
          top = rect.bottom + 10
        }

        tooltip.style.left = left + 'px'
        tooltip.style.top = top + 'px'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.right-valve {
  width: 33%;
  height: 550px;
  padding: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  background-color: white;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-section {
  position: relative;
  display: inline-block;

  .title-bg {
    width: 250px;
    height: 50px;
    object-fit: contain;
  }

  .title-text {
    position: absolute;
    top: 47%;
    left: 27%;
    transform: translate(-50%, -50%);
    color: #093d97;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    z-index: 2;
  }
}

.total-value {
  font-size: 24px;
  margin-right: 10px;
  font-style: italic;

  .number {
    font-weight: 700;
    color: #0a8d97;
  }

  .unit {
    font-size: 14px;
    font-weight: 600;
    color: #92cbd7;
    margin-left: 2px;
  }
}

/* 进度条列表样式 */
.progress-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 430px;
  overflow-y: auto;
  padding-right: 5px;
  margin-top: 10px;
}

.progress-list::-webkit-scrollbar {
  display: none;
}

.progress-item {
  background-color: rgba(242, 249, 255, 1);
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0px 0px 5px rgba(131, 178, 178, 0.196078431372549);
}

.progress-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.percentage {
  color: #0085ff;
  font-weight: 600;
  font-size: 14px;
  min-width: 50px;
}

.progress-bar {
  flex: 1;
  height: 10px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(270deg, rgba(155, 255, 248, 1) 1%, rgba(0, 133, 255, 1) 99%);
  border-radius: 4px;
  transition: width 0.3s ease;
  box-shadow: 0px 0px 5px rgba(131, 178, 178, 0.196078431372549), 0px 0px 2px 1px rgba(255, 255, 255, 0.996078431372549) inset;
}

.label {
  color: #333;
  font-weight: 500;
  font-size: 14px;
  min-width: 50px;
}

/* 自定义悬浮提示样式 */
.custom-tooltip {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0;
  max-width: 200px;
}

.tooltip-content {
  padding: 8px 12px;
}

.tooltip-title {
  font-weight: bold;
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}

.tooltip-item {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 2px;
}

.tooltip-item:last-child {
  margin-bottom: 0;
}
</style>
